import { render, staticRenderFns } from "./DialogCustomerForm.vue?vue&type=template&id=c651712e&"
import script from "./DialogCustomerForm.vue?vue&type=script&lang=js&"
export * from "./DialogCustomerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports